
export const LOAD_SYSTEM_SETTINGS_REQUEST = 'SYSTEM_SETTINGS/LOAD/REQUEST';
export const LOAD_SYSTEM_SETTINGS_SUCCESS = 'SYSTEM_SETTINGS/LOAD/SUCCESS';
export const LOAD_SYSTEM_SETTINGS_FAIL = 'SYSTEM_SETTINGS/LOAD/FAIL';
export const SAVE_SYSTEM_SETTINGS_REF = 'SYSTEM_SETTINGS/SAVE/REF';
